import { useDispatch } from 'react-redux'
import {textareaDialog} from 'actions'
import { TextFieldProps } from '@material-ui/core'

type TextareaPayload = {
  title: string,
  InputProps?: Partial<TextFieldProps>
  buttonText?: string
  validate?: (name: string) => string | null
}

const useTextarea = (payload = {} as TextareaPayload): (() => Promise<string>) => {
  const dispatch = useDispatch();

  return () => {
    return new Promise((resolve, reject) => {
      dispatch(textareaDialog({...payload, resolve, reject}))
    })
  }
}

export default useTextarea;